import React from "react";
import { MDCAnchorMenu, MDCMenu } from "../../jsx/components/mdc-components";
export default class UtmFilter extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    var color = this.props.color;
    if (!color) color = 'primary';
    var cls = `heading-label ${color} dropdown`;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("span", {
      className: "heading-span"
    }, this.props.name), /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button with-heading",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons dark-color"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "city",
      "data-id": "city"
    }, "City"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "postal_code",
      "data-id": "postal_code"
    }, "Postal Code"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "region_code",
      "data-id": "region_code"
    }, "Region Code"))));
  }
}